import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaShoppingCart, FaStar } from 'react-icons/fa';
import './DealsSection.css';
import API_BASE_URL from './config';

const categories = ['All Deals', 'Restaurants', 'Retail', 'Spa & Wellness', 'Entertainment', 'Health'];

const DealsSection = ({ onShowAffiliateDeals }) => {
  const [activeCategory, setActiveCategory] = useState('All Deals');
  const [deals, setDeals] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false); // New
  const [error, setError] = useState(null); // New
  const location = useLocation();
  const [visibleCount, setVisibleCount] = useState(8);


  const fetchDeals = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_BASE_URL}/api/deals`);
      if (!response.ok) throw new Error(`Failed to fetch deals: ${response.status} ${response.statusText}`);
      const data = await response.json();
      const approvedDeals = data.filter(deal => deal.isApproved); // ✅ only approved
      setDeals(approvedDeals);
    } catch (error) {
      console.error('Error fetching deals:', error.message);
      setError(`Unable to load deals: ${error.message}. Please check if the server is running.`);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const category = params.get('category');
    const search = params.get('search');
    if (category) setActiveCategory(category);
    if (search) setSearchQuery(search);

    fetchDeals();
    const interval = setInterval(fetchDeals, 30000); // Poll every 30 seconds
    return () => clearInterval(interval);
  }, [location, fetchDeals]);

  const filteredDeals = deals.filter((deal) => {
    const matchesCategory =
      activeCategory === 'All Deals' ||
      deal.category === activeCategory;

    const matchesSearch =
      !searchQuery ||
      deal.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      deal.merchantName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      deal.category?.toLowerCase().includes(searchQuery.toLowerCase());

    return matchesCategory && matchesSearch;
  });

    const handleViewMore = () => {
    const newCount = visibleCount + 6;
    setVisibleCount(newCount);

    if (
      activeCategory === 'All Deals' &&
      typeof onShowAffiliateDeals === 'function'
    ) {
      onShowAffiliateDeals();
    }
  };

  return (
    <div className="deals-section">
      <h2>Exclusive Deals</h2>
      <p>Discover unbeatable discounts from top merchants like Krishna Hospital and more!</p>

      <div className="category-buttons">
        {categories.map((cat) => (
          <button
            key={cat}
            className={activeCategory === cat ? 'active' : ''}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {loading && <p className="loading">Loading deals...</p>}
      {error && <p className="error">{error}</p>}

      <div className="deals-grid">
        {filteredDeals.slice(0, visibleCount).map(deal => (
          <div className="deal-card" key={deal._id}>
            <img src={`/uploads/${deal.image}`} alt={deal.title || "Deal"} />
            <div className="deal-badge">{deal.discountType === 'Percentage' ? `${deal.discountValue}% Off` : `₹${deal.discountValue} Off`}</div>
            <div className="deal-info">
              <h4>{deal.title}</h4>
              <span className="merchant-name">{deal.merchantName}</span> {/* New */}
              {deal.profitMargin > 20 && (
                <span className="perk-badge">🎁 Free Gift!</span> /* New */
              )}
              <span className="expiry">
                Expires {new Date(deal.endDate).toLocaleDateString('en-IN')}
              </span>
              <p className="desc">{deal.description}</p>
              <div className="rating-price">
                <div className="rating">
                  <FaStar className="star" /> {deal.rating || 4.5}
                  <span className="reviews">({deal.reviews || 50} reviews)</span>
                </div>
                <div className="price">
                  <span className="original">₹{deal.mrp}</span>
                  <span className="new">₹{deal.customerBuyPrice}</span>
                </div>
              </div>
              <Link to={`/deals/${deal._id}`} className="view-btn">
                View Deal <FaShoppingCart />
              </Link>
            </div>
          </div>
        ))}
      </div>
      {visibleCount < filteredDeals.length && (
        <div className="view-more-container">
          <button className="view-more-btn" onClick={handleViewMore}>
            View More Deals
          </button>
        </div>
      )}
    </div>
  );
};

export default DealsSection;